export interface ISubscription {
  description?: string;
  durationAmountTitle?: string;
  durationInDay?: number;
  durationUnitTitle?: string;
  identifier?: number;
  planIconPath?: string;
  planId?: string;
  popularPlan?: boolean;
  product?: IProductSubscription;
  themeColor?: string;
  title?: string;
  planType: PlanTypeItems;
}

export enum PlanTypeItems {
  simple = 0,
  recurring = 1
}

export interface IProductSubscription {
  accessMode?: string;
  audioBook?: string;
  discount: IDiscountSubscription | null;
  discountedPrice?: number;
  euroPrice?: string;
  giftCode?: string;
  hasTrial?: boolean;
  isCredit?: boolean;
  isGift?: boolean;
  isSubscription?: boolean;
  limitedToSubscription?: boolean;
  price?: number;
  priceDesc?: string;
  productId?: string;
  publicationType?: string;
  sku?: string;
  subscriptionPlan?: string;
  title?: string;
}

export interface IDiscountSubscription {
  allowSimultaneousPromotions?: boolean
  maximumDiscount?: number;
  minimumPrice?: number;
  promotionCaculationType?: number;
  promotionValue?: number;
  title?: string;
}

export interface ResponseProcessWithDirectDebit {
  status: DirectDebitStatus,
  data: string;
}


export enum DirectDebitStatus {
  CreateContract = 0,
  PurchaseDone = 1,
  ShowError = 2,
}
